import React, { useEffect, useState } from 'react';
import { Flag, Sparkles } from 'lucide-react';
import { apiClient } from '../../api/client';
import { useAuth } from '../../contexts/AuthContext';

const MOTIVATION_LINES = [
  "Every small step counts — you're doing brilliantly.",
  "One challenge at a time. That's how legends are made.",
  "You showed up today. That's already a win.",
  "Progress isn't loud — it's you, right here, right now.",
  "Neo believes in you. So do we.",
  "Little by little, a little becomes a lot.",
  "The finish line gets closer every single visit.",
  "Courage is just practice in disguise.",
  "You've got this — one conversation at a time.",
  "Growth looks exactly like what you're doing right now.",
];

export const NeoJourneyBanner = () => {
  const { user } = useAuth();
  const [journey, setJourney] = useState(null);
  const [line] = useState(() => MOTIVATION_LINES[Math.floor(Math.random() * MOTIVATION_LINES.length)]);

  useEffect(() => {
    apiClient.request('/api/schools/journey/current')
      .then(setJourney)
      .catch(() => {});
  }, []);

  if (!journey?.has_journey) return null;
  const firstName = (user?.name || user?.first_name || '').split(' ')[0];

  return (
    <div
      className="px-3 sm:px-8 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white flex items-center justify-between gap-3"
      data-testid="neo-journey-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Flag size={16} className="flex-shrink-0" />
        <p className="text-sm font-semibold truncate" data-testid="neo-journey-position">
          {firstName ? `${firstName}, you're` : "You're"} on Challenge No {journey.sequence} of {journey.total_count || 20}
        </p>
      </div>
      <p className="text-xs sm:text-sm text-white/90 italic truncate hidden sm:flex items-center gap-1" data-testid="neo-journey-motivation">
        <Sparkles size={12} className="flex-shrink-0" />
        {line}
      </p>
    </div>
  );
};

export default NeoJourneyBanner;
